import React, { useEffect } from "react"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import { ConfirmEmail } from "helpers/backend_helper"
import { useLoading } from "helpers/custom_hooks"

const ConfirmMail = () => {
  const [queryParameters] = useSearchParams()
  const token = queryParameters.get("token")
  const setLoading = useLoading()
  const navigate = useNavigate()

  useEffect(() => {
    confirmEmail()
  }, [token])

  const confirmEmail = async () => {
    try {
      setLoading(true)
      const result = await ConfirmEmail(token)
      localStorage.setItem("authUser", result)
    } catch (error) {
      console.error(error)
      navigate("/404")
    }
    setLoading(false)
  }

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>Success !</h4>
                        <p className="text-muted">
                          Your Email verification was successful. You are now
                          able to login and complete the setup of your account.
                        </p>
                        <div className="mt-4">
                          <Link to="/login" className="btn btn-primary">
                            Login
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>© {new Date().getFullYear()} chipsconnect</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ConfirmMail
